import React from 'react';
import { t } from '../i18n';

const Error = () => {
    return <div>{t('web.common.error')}</div>;
}

export default Error;